// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_TOPICS = "Zp\u011bt na f\u00f3ra";
export const IN_DISCUSSION = "V diskusi";
